module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Desktop_Computer.cb342565.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Desktop_Computer.svg
// module id = 1610
// module chunks = 0